import { Chip, Container, Stack, Typography } from "@octopus-energy/coral/atoms"
import { IconMask } from "@octopus-energy/icons"
import { useSession } from "@/lib/blueprint-auth/client"

export const MasqueradeBadge = () => {
    const { data: session } = useSession()

    if (session.authMethod !== "masquerade") return null

    return (
        <Container
            position="fixed"
            top={80}
            left="3%"
            zIndex={51}
        >
            <Chip color="error500">
                <Stack
                    gap="xs"
                    alignItems="center"
                >
                    <IconMask />
                    <Typography textStyle={"caption"}>
                        <strong>Masquerade</strong>
                    </Typography>
                </Stack>
            </Chip>
        </Container>
    )
}
